<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createByName="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createTime }}</span>
        </div>
      </template>
      <template v-slot:modifyByName="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyTime }}</span>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.bizSysRoleStatus === 'Y' ? 'light' : 'warning'"
          >{{
            row.bizSysRoleStatusName ? row.bizSysRoleStatusName : '--'
          }}</el-tag
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <b-button
              :disabled="row.bizSysRoleStatus === 'N'"
              class="mr-2"
              v-b-tooltip.hover
              title="查看"
              @click="fromLoad('detail', row.bizSysRoleID)"
              variant="outline-secondary"
              size="sm"
            >
              <b-icon-eye></b-icon-eye>
            </b-button>
            <b-button
              :disabled="row.bizSysRoleStatus === 'N'"
              class="mr-2"
              v-b-tooltip.hover
              title="修改"
              @click="fromLoad('edit', row.bizSysRoleID)"
              variant="outline-secondary"
              size="sm"
              v-allow="'actModify'"
            >
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button
              :disabled="row.bizSysRoleStatus === 'N'"
              class="mr-2"
              v-b-tooltip.hover
              title="复制"
              @click="copyRole(row.bizSysRoleID)"
              variant="outline-secondary"
              size="sm"
              v-allow="'actCopy'"
            >
              <b-icon-arrow-left-right></b-icon-arrow-left-right>
            </b-button>
            <b-button
              v-b-tooltip.hover
              class="mr-2"
              title="删除"
              :disabled="row.bizSysRoleStatus === 'N'"
              @click="del(row.bizSysRoleID, '删除')"
              variant="outline-secondary"
              size="sm"
              v-allow="'actDel'"
            >
              <b-icon-trash-fill></b-icon-trash-fill>
            </b-button>
            <b-button
              v-b-tooltip.hover
              title="恢复"
              :disabled="row.bizSysRoleStatus === 'Y'"
              @click="del(row.bizSysRoleID, '恢复')"
              variant="outline-secondary"
              size="sm"
              v-allow="'actDel'"
            >
              <b-icon-arrow-repeat></b-icon-arrow-repeat>
            </b-button>
          </b-button-group>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'left',
          width: 250,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        // { width: 50, fixed: "left", type: "checkbox" },
        {
          field: 'seq',
          width: 60,
          align: 'left',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'bizSysRoleName',
          minWidth: 380,
          title: '角色名称',
          sortable: true,
          sortType: 'string',
        },
        {
          field: 'bizSysRoleStatusName',
          align: 'left',
          width: 100,
          title: '状态',
          slots: { default: 'status' },
        },
        {
          field: 'createTime',
          width: 200,
          align: 'left',
          title: '创建人',
          sortable: true,
          slots: { default: 'createByName' },
        },
        {
          field: 'modifyTime',
          sortable: true,
          width: 200,
          align: 'left',
          title: '修改人',
          slots: { default: 'modifyByName' },
        },
      ],
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    reload() {
      this.$emit('submit')
    },
    getHeight() {
      this.tableHeight = window.innerHeight - 195
    },
    // 加载表单
    fromLoad(ref, val = '') {
      let params = {
        type: ref,
        bizSysRoleID: val,
      }
      // 跳转页面
      this.$router.push({
        name: 'system-roleDetail',
        params: params,
      })
    },
    copyRole(bizSysRoleID) {
      this.$confirm('确定要复制吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api
            .sysRoleCopyApi({ bizSysRoleID: bizSysRoleID })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'success',
                })
                this.back()
              }
            })
        })
        .catch(() => {})
    },
    del(bizSysRoleID, msg) {
      this.$confirm('确定要' + msg + '吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api
            .sysRoleDelApi({ bizSysRoleID: bizSysRoleID })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  showClose: true,
                  message: msg + '成功',
                  type: 'success',
                })
                this.back()
              }
            })
        })
        .catch(() => {})
    },
    back() {
      this.$emit('submit')
    },
  },
}
</script>
